<template><div><h1 id="beteiligte" tabindex="-1"><a class="header-anchor" href="#beteiligte"><span>Beteiligte</span></a></h1>
<p>Beteiligte — Beteilgte Personen bei Anlassspenden</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle kann eine beliebige Anzahl von beteilgten Peronen zu einem <RouteLink to="/referenz/refs/ft.refdata.anlass.html" title="Anlass">Anlass</RouteLink> erfasst werden. Jeder Person muss eine Rolle (z.B. Braut, Bräutigam oder BrautführerIn) zugeordnet werden.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Anlassspenden → Rollen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Adresse / Name und Adresse</dt>
<dd>Die beteiligte Person muss als Adresse in funtrade erfasst sein.</dd>
<dt>Rolle</dt>
<dd>Lookup auf Rolle der beteilgten Peron. Mit der Rolle wird die Art der Beteiligung definiert, z.B. Empfängeradresse für Einzahlungsscheine oder &quot;Beschenkte/r&quot;.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/anlassspenden.html" title="2. Anlassspenden">Anlassspenden</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.anlass.html" title="Anlass">Anlass</RouteLink></p>
</div></template>


